import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Alert, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import ForgetPassword from "./ForgetPassword";
import {
  getCountryActiveListApi,
  sendLoginRamNamOtpApi,
} from "../ramnambook-registration/RamNamBookCRUD";

// ✅ Validation schema
const schema = Yup.object({
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Enter valid 10-digit mobile number"),
});

const LoginPage = ({ show, onHide }) => {
  // const LoginPage = (props) => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [countryID, setCountryID] = useState(0);
  const [showForgetPassword, setShowForgetPassword] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  // ✅ Load country list
  useEffect(() => {
    getCountryActiveDataListApi();
  }, []);

  const getCountryActiveDataListApi = async () => {
    try {
      const res = await getCountryActiveListApi();
      if (res.data.isSuccess) {
        setCountries(res.data.responseObject);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ Submit handler (WORKING)
  const onSubmit = async ({ mobileNumber }) => {
    try {
      const response = await sendLoginRamNamOtpApi(mobileNumber);

      if (response.data.isSuccess) {
        toast.success(response.data.message);

        navigate("/verify-otp", {
          state: {
            otpdata: response.data.data,
            mode: "login",
            mobileNumber,
          },
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Failed to send OTP. Please try again.");
    }
  };

  const handleOpenMemberSite = () => {
    window.open(
      "https://demo.khunkhaarmeldimaabareja.com/book-registration",
      "_blank"
    );
    // window.open("http://localhost:3011", "_blank");
  };
  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton />
      <Modal.Body
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "300px" }}
      >
        <div className="p-4 bg-light" style={{ width: "400px" }}>
          <h6 className="text-center mb-4 text-danger">Login</h6>

          {errors.root && <Alert variant="danger">{errors.root.message}</Alert>}

          <Form onSubmit={handleSubmit(onSubmit)} noValidate>
            {/* 📱 Mobile Number */}
            <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>

              <InputGroup>
                <Form.Select
                  value={countryID}
                  onChange={(e) => setCountryID(e.target.value)}
                  style={{ maxWidth: "105px" }}
                >
                  {countries.map((c) => (
                    <option key={c.countryID} value={c.countryID}>
                      {c.countryCode} {c.countryDialNumber}
                    </option>
                  ))}
                </Form.Select>

                <Form.Control
                  type="text"
                  placeholder="Enter 10-digit mobile number"
                  maxLength={10}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...register("mobileNumber", {
                    onChange: (e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setValue("mobileNumber", value);
                      clearErrors("root");
                    },
                  })}
                  isInvalid={!!errors.mobileNumber}
                  autoFocus
                  autoSave="true"
                />

                <Form.Control.Feedback type="invalid">
                  {errors.mobileNumber?.message}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            {/* ✅ Submit */}
            <Button
              type="submit"
              className="w-100"
              style={{ backgroundColor: "#FF4F00", border: "none" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending OTP..." : "Login & Send OTP"}
            </Button>
          </Form>

          <p className="text-center mt-3">
            Don’t have an account?{" "}
            <span
              className="text-primary cursor-pointer"
              onClick={handleOpenMemberSite}
            >
              Register
            </span>
          </p>

          <ForgetPassword
            show={showForgetPassword}
            onHide={() => setShowForgetPassword(false)}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoginPage;
